import React, { useState } from 'react';
import { Sidebar } from '../moderator/Sidebar';

export function SlaughterWeight() {
  const [slaughterData, ] = useState([]);

  return (
    <>
      <Sidebar />
      <div className="ml-64 p-8">
        <h1 className="text-2xl font-bold mb-6">Slaughter Weight Report</h1>
        
        <div className="bg-white rounded-lg shadow p-6">
          <div className="flex justify-between items-center mb-4">
            <h2 className="text-lg font-semibold">Slaughter Details</h2>
            <div className="flex space-x-2">
              <select className="border rounded p-2">
                <option value="">All Types</option>
                <option value="cow">Cow</option>
                <option value="goat">Goat</option>
                <option value="camel">Camel</option>
              </select>
              <input type="date" className="border rounded p-2" />
              <button className="bg-green-500 text-white px-4 py-2 rounded hover:bg-green-600">
                Export
              </button>
            </div>
          </div>
          
          <div className="overflow-x-auto">
            <table className="min-w-full">
              <thead className="bg-gray-50">
                <tr>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Animal ID</th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Type</th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Live Weight</th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Meat Weight</th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Waste Weight</th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Slaughter Date</th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Butcher</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-200">
                {slaughterData.map((item, index) => (
                  <tr key={index}>
                    <td className="px-6 py-4">{item.animalId}</td>
                    <td className="px-6 py-4">{item.type}</td>
                    <td className="px-6 py-4">{item.liveWeight} kg</td>
                    <td className="px-6 py-4">{item.meatWeight} kg</td>
                    <td className="px-6 py-4">{item.wasteWeight} kg</td>
                    <td className="px-6 py-4">{item.slaughterDate}</td>
                    <td className="px-6 py-4">{item.butcherName}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          <div className="mt-4 grid grid-cols-1 md:grid-cols-3 gap-4">
            <div className="bg-gray-50 p-4 rounded">
              <h3 className="text-sm font-medium text-gray-500">Average Live Weight</h3>
              <p className="text-xl font-bold">320 kg</p>
            </div>
            <div className="bg-gray-50 p-4 rounded">
              <h3 className="text-sm font-medium text-gray-500">Average Meat Weight</h3>
              <p className="text-xl font-bold">180 kg</p>
            </div>
            <div className="bg-gray-50 p-4 rounded">
              <h3 className="text-sm font-medium text-gray-500">Efficiency Rate</h3>
              <p className="text-xl font-bold">56.25%</p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}